
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const Header = () => {
  return (
    <header className="py-4 px-6 bg-white sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-primary rounded-md flex items-center justify-center">
            <span className="text-white font-bold text-xl">AI</span>
          </div>
          <span className="font-bold text-dark text-xl hidden sm:inline-block">KI-Wissensplattform</span>
        </div>
        
        <nav className="hidden md:flex items-center gap-8">
          <a href="#core-features" className="text-grey hover:text-primary transition-colors">Features</a>
          <a href="#benefits" className="text-grey hover:text-primary transition-colors">Vorteile</a>          
          <a href="#contact" className="text-grey hover:text-primary transition-colors">Kontakt</a>
        </nav>
        
        <a href="#contact">
          <Button className="bg-primary hover:bg-primary/90 text-white flex gap-2 items-center">
            <span>Beratungstermin</span>
            <ArrowRight size={16} />
          </Button>
        </a>
      </div>
    </header>
  );
};
//<a href="#testimonials" className="text-grey hover:text-primary transition-colors">Referenzen</a>
export default Header;
